import styled from 'styled-components';
import media from '@theme/media';

export const Container = styled.div`
  display: flex;
  justify-content: ${({ centered }) => (centered ? 'center' : 'flex-end')};
  > #dashboard-table-pagination {
    margin-left: 30px;
  }
  flex-direction: column;
  margin-top: 20px;
  ${media.large} {
    flex-direction: row;
    margin-top: 0;
  }
`;

export const TranscriptsLoaderStyle = {
  width: 'auto',
  marginTop: '10px',
  display: 'flex',
  justifyContent: 'center',
};



// WEBPACK FOOTER //
// ./components/layout/DashboardPage.js